// extracted by mini-css-extract-plugin
export default {"mainContainer":"userMenu_mainContainer__-gHBx","ul":"userMenu_ul__--nmo","visitSite":"userMenu_visitSite__31c+G"};